import { useRouter } from "@tanstack/react-router";

import { DisposicionSitio } from "@/components/medam/sitio";
import { Button } from "@/components/ui/button";

type RouteErrorBoundaryProps = {
  error: Error;
  reset: () => void;
  titulo: string;
  descripcion: string;
};

export function RouteErrorBoundary({ error, reset, titulo, descripcion }: RouteErrorBoundaryProps) {
  const router = useRouter();

  return (
    <DisposicionSitio>
      <div className="mx-auto max-w-3xl px-4 py-24 text-center">
        <h1 className="font-display text-2xl">{titulo}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{descripcion}</p>
        <p className="mt-2 text-xs text-muted-foreground">
          {error.message || "Error inesperado al cargar esta sección."}
        </p>
        <div className="mt-6 flex justify-center gap-2">
          <Button
            onClick={() => {
              router.invalidate();
              reset();
            }}
          >
            Reintentar
          </Button>
          <Button asChild variant="outline">
            <a href="/">Volver al inicio</a>
          </Button>
        </div>
      </div>
    </DisposicionSitio>
  );
}
